export enum DisplayerKeys {
  BROWSER = 'browser',
  MOBILE = 'mobile'
}

export enum DisplayerServiceKeys {
  STORAGE = 'displayer-decision',
  QUERY_CODE = 'qrcode'
}
